import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["column", "row", "value", "onChange"];
import React, { useCallback, useMemo } from 'react';
import { createUseStyles, Text } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';
import { SmallIcon, VerticalIcon, HorizontalIcon, BigIcon } from "./icons";
import { useWeb5Context } from "../../../../lib/Web5Context";
import styles from "./styles";
const useStyles = createUseStyles(styles);
const ICONS = {
  small: /*#__PURE__*/React.createElement(SmallIcon, null),
  vertical: /*#__PURE__*/React.createElement(VerticalIcon, null),
  horizontal: /*#__PURE__*/React.createElement(HorizontalIcon, null),
  big: /*#__PURE__*/React.createElement(BigIcon, null)
};
function Size(_ref) {
  let {
      column,
      row,
      value,
      onChange
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const classes = useStyles();
  const {
    t
  } = useWeb5Context();
  const onClick = useCallback(() => onChange && onChange({
    columns: column,
    rows: row
  }), [column, onChange, row]);
  const size = useMemo(() => {
    if (column !== 3 && row === 1) return 'small';
    if (column === 3 && row === 1) return 'horizontal';
    if (column !== 3 && row === 2) return 'vertical';
    if (column === 3 && row === 2) return 'big';
  }, [column, row]);
  const selected = useMemo(() => row === (value === null || value === void 0 ? void 0 : value.rows) && (column === (value === null || value === void 0 ? void 0 : value.columns) || column === 2 && (value === null || value === void 0 ? void 0 : value.columns) === 1), [column, row, value === null || value === void 0 ? void 0 : value.columns, value === null || value === void 0 ? void 0 : value.rows]);
  const classNames = classnames(classes.size, `widgets-form__size--${size}`, {
    [classes.selected]: selected
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames,
    onClick: onClick
  }, props), /*#__PURE__*/React.createElement("div", {
    className: classes.icon
  }, ICONS[size]), /*#__PURE__*/React.createElement(Text, {
    type: "caption",
    className: classes.text
  }, t(`cfm_label_${size}`)));
}
export default Size;